export {
    bgImagesUrlx1,
    bgImagesUrlx2,
    bgImagesUrlx3,
    logoAmazonImagesUrlx1,
    logoAmazonImagesUrlx2,
    logoAmazonImagesUrlx3,
    allpeBookImagesUrlx1,
    allpeBookImagesUrlx2,
    allpeBookImagesUrlx3,
    bookShopImagesUrlx1,
    bookShopImagesUrlx2,
    bookShopImagesUrlx3,
    dumpImagesUrl,
}

const bgImagesUrlx1 = new URL (
    `../../images/shoppingList-clear--bg-x1.png`,    
    import.meta.url
);
const bgImagesUrlx2 = new URL (
    `../../images/shoppingList-clear--bg-x2.png`,    
    import.meta.url
);
const bgImagesUrlx3 = new URL (
    `../../images/shoppingList-clear--bg-x3.png`,    
    import.meta.url
);

const logoAmazonImagesUrlx1 = new URL(
    `../../images/shoppingList--logoAmazon--x1.png`,
    import.meta.url
);
const logoAmazonImagesUrlx2 = new URL(
    `../../images/shoppingList--logoAmazon--x2.png`,
    import.meta.url
);
const logoAmazonImagesUrlx3 = new URL(
    `../../images/shoppingList--logoAmazon--x3.png`,
    import.meta.url
);

const allpeBookImagesUrlx1 = new URL(
    `../../images/shoppingList--appleBook--x1.png`,
    import.meta.url
);
const allpeBookImagesUrlx2 = new URL(
    `../../images/shoppingList--appleBook--x2.png`,
    import.meta.url
);
const allpeBookImagesUrlx3 = new URL(
    `../../images/shoppingList--appleBook--x3.png`,
    import.meta.url
);

const bookShopImagesUrlx1 = new URL(
    `../../images/shoppingList--bookShop--x1.png`,
    import.meta.url
);
const bookShopImagesUrlx2 = new URL(
    `../../images/shoppingList--bookShop--x2.png`,
    import.meta.url
);
const bookShopImagesUrlx3 = new URL(
    `../../images/shoppingList--bookShop--x3.png`,
    import.meta.url
);

const dumpImagesUrl = new URL (
    `../../images/remove-book-btn.svg`,    
    import.meta.url
);
